import * as d3 from 'd3';
import * as d3Annotation from 'd3-svg-annotation';
import * as d3Textwrap from 'd3-textwrap';
import Chart from '../chart';

import subMetrics from '../../data/overview.json'
import cities from '../../data/cities.json'
import tvCities from '../../data/tvCities.json'
import conceptQuestions from '../../data/conceptQuestions.json'

import './TvSurveyRosace.css';

export const regionLabels = {
  "Mechelen binnenstad": {
    en: "Inner city",
    nl: "Binnenstad",
  },
  "Mechelen buitenstad": {
    en: "Outer city",
    nl: "Buitenstad",
  },
  "Brugge buiten stad": {
    en: "Outer city",
    nl: "Buitenstad",
  },
  "Brugge binnenstad": {
    en: "Inner city",
    nl: "Binnenstad",
  },
  "Leuven buiten stad": {
    en: "Outer city",
    nl: "Buitenstad",
  },
  "Antwerpen Kernstad": {
    en: "Inner Leien",
    nl: "Kernstad",
  },
  "Gent 2-3": {
    en: "Outer city ring",
    nl: "Buitenring",
  },
  "Antwerpen rest": {
    en: "Linkeroever",
    nl: "Linkeroever",
  },
  "Gent 1-4": {
    en: "Inner city ring",
    nl: "Binnenstad",
  },
  "Gent rest": {
    en: "Rest",
    nl: "Rest",
  },
  "Antwerpen binnenstad": {
    en: "Outer Leien",
    nl: "Binnenstad",
  },
  "Leuven binnenstad": {
    en: "Inner city",
    nl: "Binnenstad",
  },
}

export default class TvSurveyRosace extends Chart {
  // First step of the D3 rendering.
  create() {
    this.svg = super.createRoot();
    this.main = this.svg.append('g')
      .attr('class', 'main')
      .attr('transform', `translate(${this.props.width / 2},${this.props.height / 2})`);
    this.props.width = Math.min(this.props.width, this.props.height)

    this.mainLabels = this.main.append('g')
      .attr('class', 'mainLabel');
  
    this.subLabel = this.main.append('g')
      .attr('class', 'subLabel');

    this.subMetricBack = this.main.append('g')
      .attr('class', 'subMetricBack');

    this.yAxis = this.main.append('g')
      .attr('class', 'yAxis');

    this.clover = this.main.append('g')
      .attr('class', 'clover');

    this.centralImage = this.main.append('g')
      .attr('class', 'centralImage');

    this.map = this.main.append('g')
      .attr('class', 'map');

    this.questionHighlight = this.main.append('g')
      .attr('class', 'questionHighlight')
    
    /*this.questionHighlight
      .append('path')
      .attr('class', 'arrow')
      .attr('fill', '#ffe615')
      .attr('stroke', 'white')
      .attr('stroke-width', 1.5)
      .attr('d', d3.symbol().type(d3.symbolTriangle));*/

    this.questionHighlight
      .append('path')
      .attr('class', 'background')
      .attr('fill', '#ffe615');

    this.subMetric = this.main.append('g')
      .attr('class', 'subMetric');

    this.annotations = this.main.append('g')
      .attr('class', 'annotation-group')

    this.year = this.main.append('g')
      .attr('class', 'year')
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    if (state && state.data) {
      this.data = state.data;
      this.subMetrics = subMetrics;
      this.pop = state.pop;
      this.curved = state.curved;
      this.setTooltip = state.setTooltip;
      this.linearTransitionTime = state.linear !== this.linear ? 2000 : 300;
      this.linear = state.linear;
      this.metric = state.metric;
      this.city = state.city;
      this.selectQuestion = state.selectQuestion;
      if (this.selectedQuestion !== state.selectedQuestion) {
        this.clickedConcept = null;
      }
      this.selectedQuestion = state.selectedQuestion;
      this.concept = state.concept;
      this.locale = state.locale === 'en' ? 'En' : 'Nl';
      this.intl = state.intl
      this.draw(state);
      //this.subMetric.selectAll('text').call(this.wrap)
    } 
  }

  draw(state) {
    const radiusMulti = 60;
    this.radius = state.linear ? this.props.width * radiusMulti : this.props.width / 2;
    this.mainLabelRange = state.linear ? [1 - (this.props.width / this.radius), (1 - (this.props.width / this.radius)) +  (0.025 * (this.props.width / this.radius))] : [0.4, 0.45];
    this.subMetricRange = state.linear ? [ (1 - (this.props.width / this.radius)) +  (0.035 * (this.props.width / this.radius)), 1 - (0.1 * (this.props.width / this.radius))] : [0.47, 0.80];
    
    this.wrap = d3Textwrap.textwrap().bounds({ height: 400, width: 0.15 * this.radius }).method('tspans')

    this.angle = state.linear ? Math.atan(1/radiusMulti) : 2 * Math.PI;
    this.padAngle = state.linear ? Math.atan(1/radiusMulti) * 0.01 : 0.01;
    this.main
      .transition()
      //.ease(d3.easeQuad)  
      .duration(this.linearTransitionTime)
      //.attr('transform', `translate(${state.linear ? -this.radius * this.mainLabelRange[0] : this.props.width / 2},${state.linear ? 0 : this.props.height / 2})`);

    this.drawCentralImage();
    const mainSubdivisions = this.drawMainLabel(state);
    this.drawSubmetrics(mainSubdivisions)
    //const subDivisions = this.drawSubmetrics(mainSubdivisions)
    //const groupSubDivisions = subDivisions
    //  .filter(sub => sub.data.img)
    //this.drawGroupPictures(groupSubDivisions)
    //this.drawScore(subDivisions)
    this.drawClover(state)
    this.addTooltip()
    this.drawQuestionHighlight()
    this.drawMap();
    this.drawAnnotations();
    if(this.yAxis.selectAll('circle').empty()) { this.drawAxis(); } 
    this.drawYear();
    //this.year.style('opacity', (state.concept === 'support' || state.concept === 'impact') ? 1 : 0)
  }

  addTooltip() {
    const setTooltip = this.setTooltip
    const self = this
    function mouseenter(d) {
      self.hoveredConcept = d;
      self.drawMap()
      /*d3.select(this)
        .style('stroke', 'black')
        .style('stroke-width', 2)*/
    }
    function mousemove(d) {
      setTooltip({ 
       position: { x: d3.event.pageX + 10, y: d3.event.pageY + 10 },
       content: {
         title: d.data.question.ref,
         data: {
           ...d.data,
           ...conceptQuestions.find(q => q.reference === d.data.question.ref)
          },
       },
     })
    }
    function mouseleave() {
      setTooltip(null);
      //self.hoveredConcept = self.clickedConcept ? self.clickedConcept : null;
      self.hoveredConcept = null;
      self.drawMap();
      self.drawAnnotations();
      /*d3.select(this)
        .style('stroke', 'none')*/
    }
    function click(d) {
      self.clickedConcept = !self.clickedConcept || d.data.question.ref !== self.clickedConcept.data.question.ref ? d : null;
      //debugger
      self.selectQuestion(d.data.question.ref)
      self.drawMap();
    }
    this.subMetricBack.selectAll('.sub-metric-background')
      .on('mouseenter', mouseenter)
      .on('mousemove', mousemove)
      .on('mouseleave', mouseleave)
      .on('click', click)
  }

  drawCentralImage() {
    const width = this.props.width * this.subMetricRange[0] * 0.6;

    if (this.centralImage.selectAll('.centralImage').empty()) {
      this.centralImage.append('filter')
        .attr('id','desaturate')
        .append('feColorMatrix')
        .attr('type','matrix')
        .attr('values',"0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0");

      this.centralImage.append("svg:image")
        .attr('class', 'centralImage')
    }
    this.centralImage.selectAll('.centralImage')
      .transition()
      .duration(this.linearTransitionTime * 2)
      .attr('x', -width / 2)
      .attr('y', -width / 2)
      .attr('width', width)
      .attr('height', width)
      .attr('xlink:href', require(`../../assets/images/allCities.png`))
      //.attr('xlink:href', require(`../../assets/images/tv-bw.png`))
      //.style('filter', this.pop ? '' : 'url(#desaturate)')
      .style('opacity', this.city === 'all' ? 1 : 0)
  }

  getSelectedConcept() {
    const self = this;
    let selectedConcept = null;
    this.subMetricBack
      .selectAll('.sub-metric-background')
      .each(function(d) {
        if (d.data.question.ref === self.selectedQuestion) {
          selectedConcept = d;
        }
      })
    selectedConcept = this.hoveredConcept ? this.hoveredConcept : ( this.clickedConcept ? this.clickedConcept : selectedConcept );
    return selectedConcept;
  }

  drawMap() {    
    const selectedConcept = this.getSelectedConcept();

    const mapColor = selectedConcept ? selectedConcept.data.mainColor : null;
    const width = this.props.width * this.subMetricRange[0] * 0.6;
    const geojson = this.city && this.city !== 'all' ? cities[this.city.toUpperCase()] : { features: [] }
    const tvGeojson = this.city && this.city !== 'all' ? 
      {...tvCities, features: tvCities.features.filter(f => f.properties.Stad === this.city)} : { features: [] }
    const projection = d3.geoMercator()
  	  .fitExtent([[0, 0], [width, width]], geojson);

    var path = d3.geoPath()
      .projection(projection);

    this.map.selectAll('.mapBackColor')
      .data(geojson.features, d => d.properties.Shape_Area)
      .join( 
        enter => enter.append('path')
          .attr('class', 'mapBackColor')
          .attr('d', path)
          .attr('transform', `translate(${0}, ${0}) scale(0)`)
          .style('fill', 'white')
          .style('stroke', 'none'),
        update => update
          //.style('opacity', (d, i) => this.mapColor ? random(i) : 1)
          .transition()
          .duration(500)
          .attr('transform', `translate(${-width/2}, ${-width/2}) scale(1)`),
        exit => exit
          .transition()
          .duration(500)
          .attr('transform', `translate(0, 0) scale(0)`)
          .remove()
      )
      .transition()
      .duration(500)
      .attr('transform', `translate(${-width/2}, ${-width/2}) scale(1)`)

    const maxVal = d3.max(tvGeojson.features.map(d => selectedConcept && selectedConcept.data.regions[d.properties.Wijk] ? selectedConcept.data.regions[d.properties.Wijk].weightedAgreementProportion : 0))
    const colorScale = d3.scaleLinear()
        .domain([0, maxVal])
        .range([0, 1])
    this.map.selectAll('.mapBack')
      .data(tvGeojson.features, d => d.properties.Shape_Area + ' kdlkfldf')
      .join( 
        enter => enter.append('path')
          .attr('class', 'mapBack')
          .attr('d', path)
          .attr('transform', `translate(${0}, ${0}) scale(0)`)
          .style('fill', d => mapColor || 'white')
          .style('stroke', 'black')
          .style('stroke-opacity', 1)
          .style('stroke-width', 1.5)
          .style('opacity', d => selectedConcept && selectedConcept.data.regions[d.properties.Wijk] ? colorScale(selectedConcept.data.regions[d.properties.Wijk].weightedAgreementProportion) : 0),
        update => update
          .style('fill', d => mapColor || 'white')
          .style('stroke-opacity', 1)
          .style('stroke-width', 1.5)
          .style('opacity', d => selectedConcept && selectedConcept.data.regions[d.properties.Wijk] ? colorScale(selectedConcept.data.regions[d.properties.Wijk].weightedAgreementProportion) : 0)
          .transition()
          .duration(500)
          .attr('transform', `translate(${-width/2}, ${-width/2}) scale(1)`),
        exit => exit
          .transition()
          .duration(500)
          .attr('transform', `translate(0, 0) scale(0)`)
          .remove()
      )
      .transition()
      .duration(500)
      .attr('transform', `translate(${-width/2}, ${-width/2}) scale(1)`)

    this.map.selectAll('.mapFront')
      .data(geojson.features, d => d.properties.Shape_Area + 'frontLine')
      .join( 
        enter => enter.append('path')
          .attr('class', 'mapFront')
          .attr('d', path)
          .attr('transform', `translate(${0}, ${0}) scale(0)`)
          .style('fill', 'none')
          .style('stroke', 'black')
          .style('stroke-width', 0.05),
        update => update
          .transition()
          .duration(500)
          .attr('transform', `translate(${-width/2}, ${-width/2}) scale(1)`),
        exit => exit
          .transition()
          .duration(500)
          .attr('transform', `translate(0, 0) scale(0)`)
          .remove()
      )
      .transition()
      .duration(500)
      .attr('transform', `translate(${-width/2}, ${-width/2}) scale(1)`)
  }

  drawAnnotations() {
    const type = d3Annotation.annotationLabel
    const annotationCity = {
      Antwerpen:
        [
          {
            id: 1,
            note: {
              title: "Antwerpen Kernstad",
            },
            x: 21.37704918032787 / 274.5,
            y: 28.918032786885245 / 274.5,
            dx: 21.371584699453557 / 274.5,
            dy: -70.59562841530055 / 274.5,
          }, {
            id: 2,
            note: {
              title: "Antwerpen binnenstad",
            },
            x: 33.37158469945356 / 274.5,
            y: 33.37158469945356 / 274.5,
            dx: 37.44808743169399 / 274.5,
            dy: -36.52459016393443 / 274.5,           
          }, {
            id: 3,
            note: {
              title: "Antwerpen rest",
            },
            x: 3.2295081967213113 / 274.5, 
            y: 27.989071038251367 / 274.5, 
            dx: -60.28415300546448 / 274.5, 
            dy: -9.68534906588004 / 274.5, 
          }
      ],
      Mechelen: [
        {
          id: 1,
          note: {
            title: "Mechelen binnenstad"
          },
          x: 18 / 274.5,
          y: 12 / 274.5,
          dx: 31 / 274.5,
          dy: -47 / 274.5,
        }, {
          id: 2,
          note: {
            title: "Mechelen buitenstad"
          },
          x: -19 / 274.5,
          y: 7 / 274.5,
          dx: 6 / 274.5,
          dy: 63 / 274.5,
        }
      ],
      Leuven: [
        {
          id: 1,
          note: {
            title: "Leuven binnenstad"
          },
          x: -4 / 274.5,
          y: 8 / 274.5,
          dx: -60 / 274.5,
          dy: -32 / 274.5,
        }, {
          id: 2,
          note: {
            title: "Leuven buiten stad"
          },
          x: 14 / 274.5,
          y: 41 / 274.5,
          dx: 43 / 274.5,
          dy: -5 / 274.5,
        }
      ],
      Gent:
        [
          {
            id: 1,
            note: {
              title: "Gent 1-4",
            },
            x: 5/ 274.5,
            y: 25 / 274.5,
            dx: -43 / 274.5,
            dy: -42 / 274.5,
          }, {
            id: 2,
            note: {
              title: "Gent 2-3",
            },
            x: 10 / 274.5,
            y: -7 / 274.5,
            dx: -29 / 274.5,
            dy: -59 / 274.5,              
          }, {
            id: 3,
            note: {
              title: "Gent rest",
            },
            x: -32 / 274.5,
            y: 29 / 274.5,
            dx: -11.000000000000007 / 274.5,
            dy: 35.00294985250737 / 274.5,
          }
      ],
      Brugge: [
        {
          id: 1,
          note: {
            title: "Brugge binnenstad"
          },
          x: 1 / 274.5,
          y: 39 / 274.5,
          dx: 56 / 274.5,
          dy: -37 / 274.5,
        }, {
          id: 2,
          note: {
            title: "Brugge buiten stad"
          },
          x: -5 / 274.5,
          y: -22 / 274.5,
          dx: -53 / 274.5,
          dy: 25 / 274.5,
        }
      ],
    }
    let annotations = this.city !== 'all' ? annotationCity[this.city] : [];
    const selectedConcept = this.getSelectedConcept();
    annotations = annotations.map(a => {
      return {
        ...a,
        x: a.x * this.radius,
        y: a.y * this.radius,
        dx: a.dx * this.radius,
        dy: a.dy * this.radius,
        note: {
          title: regionLabels[a.note.title][this.locale.toLowerCase()] + (selectedConcept && selectedConcept.data.regions[a.note.title] ? ` ${Math.round(selectedConcept.data.regions[a.note.title].weightedAgreementProportion * 100)}%` : '')
        }
      }
    })

    const makeAnnotations = d3Annotation.annotation()
      //.editMode(true)
      .notePadding(0)
      .type(type)
      .annotations(annotations)

    window.makeAnnotations = makeAnnotations
    
    this.annotations
      .style('font-size', this.props.width * 0.015)
      .call(makeAnnotations)
  }

  drawClover(state) {
    if (!this.gooeyBackground) {
      var defs = this.clover.append("defs");
      var filter = defs.append("filter").attr("id","gooeyCodeFilter");
        filter.append("feGaussianBlur")
          .attr("in","SourceGraphic")
          .attr("stdDeviation","40")
          //to fix safari: http://stackoverflow.com/questions/24295043/svg-gaussian-blur-in-safari-unexpectedly-lightens-image
          .attr("color-interpolation-filters","sRGB") 
          .attr("result","blur");
        filter.append("feColorMatrix")
          .attr("class", "blurValues")
          .attr("in","blur")
          .attr("mode","matrix")
          .attr("values","1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -8")
          .attr("result","gooey");
        filter.append("feBlend")
          .attr("in","SourceGraphic")
          .attr("in2","gooey")
          .attr("operator","atop");

      this.gooeyBackground = this.clover.append('g')
        .style("filter", "url(#gooeyCodeFilter)");

      this.gooeyBackground.append('circle')
        .style('fill', '#f0f0f0')
        .attr('r', 0)
        .attr('cx', 0)
        .attr('cy', 0)
        .transition()
        .duration(2000)
        .attr('cx', -this.props.width/4)
        .attr('cy', -this.props.width/4)
        .attr('r', this.props.width/7)

      this.gooeyBackground.append('circle')
        .attr('r', 0)
        .transition()
        .duration(700)
        .style('fill', '#f0f0f0')
        .attr('cx', 0)
        .attr('cy', 0)
        .attr('r', this.props.width/6)

      this.textSelection = this.clover.append('g')
        .attr('class', 'selection')
        .attr('transform', `translate(${-this.props.width/4}, ${-this.props.width/4})`)
      
      this.citySelection = this.textSelection 
        .append('text')
        .attr('class', 'city-selection')
        .attr('transform', `translate(0, ${-this.props.width/15})`)
        .style('font-size', this.props.width*0.04)
        .style('text-anchor', 'middle')
        .style('font-family', 'Flanders Art Sans Bold')

      this.conceptSelection = this.textSelection 
        .append('text')
        .style('text-anchor', 'middle')
        .attr('transform', `translate(0, ${this.props.width/12})`)
        .attr('class', 'concept-selection')
        .style('font-size', this.props.width*0.03)

      const widthSide = this.props.width * this.subMetricRange[0] * 0.2;
      this.cityImage = this.textSelection.append("svg:image")
        .attr('class', 'sideImage')
        .attr('transform', `translate(${ - (widthSide/2)}, ${ - (widthSide/2)})`)
        .attr('width', widthSide)
        .attr('height', widthSide)
        //.attr('xlink:href', require(`../../assets/images/flanders.png`))
    }

    this.citySelection
      .text(this.intl.formatMessage({ id: `city.${state.city.toLowerCase() === 'all' ? 'allCities' : state.city.toLowerCase()}` }))//state.city === 'all' ? 'All cities' : state.city

    this.conceptSelection
      .text(this.intl.formatMessage({ id: `concept.${state.concept === 'support' || state.concept === 'impact' ? 'supportImpact' : state.concept}`}))
      //.text(state.concept === 'all' ? 'All concepts' : ( state.concept === 'support' || state.concept === 'impact' ? 'Support & Impact' : state.concept))

    this.cityImage
      .attr('xlink:href', state.city === 'all' ? require('../../assets/images/flanders.png') : require(`../../assets/images/${state.city.toLowerCase()}.png`))
  }

  drawMainLabel(state) {
    const mainLabels = this.data.map( (empowerment, i) => ({
      name: empowerment.type,
      translatedName: empowerment.type === 'economic' ? '€' : this.intl.formatMessage({ id: `subconcept.${empowerment.type}` }),
      questions: empowerment.questions,
      color: empowerment.color, //this.pop ? popColors[i%5] : softColors[i%5]
    }));

    const arcs = d3.pie()
      .startAngle(state.linear ? 90 * Math.PI/180 : -8 * Math.PI/180)
      .endAngle(state.linear ? (90 * Math.PI/180) + this.angle : -80 * Math.PI/180 + 2*Math.PI)
      .padAngle(this.padAngle * 2)
      .sort(null)
      .value(d => d.questions.length)(mainLabels)
      //.value(d => this.data.find( empowerment => empowerment.type === d.name ).questions.length)(mainLabels)
      .map(d => ({
        ...d,
        innerRadius: this.radius * this.mainLabelRange[0],
        outerRadius: this.radius * this.mainLabelRange[1] - 1,
        cornerRadius: this.radius * (this.mainLabelRange[1] - this.mainLabelRange[0]),
      }))

    const arc = d3.arc()
      .cornerRadius(this.radius * (this.mainLabelRange[1] - this.mainLabelRange[0]))

    this.mainLabels
      .selectAll('.main-label-background')
      .data(arcs)
      .join( 
        enter => enter
          .append('path')
          .attr('class', 'main-label-background')
          .attr('fill', d => d.data.color)
          .attr('d', function(d) {
            this._current = d;
            return arc(d);
          }),
        update => update
          .transition()
          .duration(this.linearTransitionTime)
          .attr('fill', d => d.data.color)
          .attrTween('d', function(a) {
            const i = d3.interpolate(this._current, a);
            this._current = i(0);
            return (t) => arc(i(t));
          })
      )

    const middleArcLine = d => {
      const halfPi = Math.PI/2;
      const angles = [d.startAngle - halfPi, d.endAngle - halfPi];
      const r = Math.max(0, d.innerRadius + d.outerRadius) / 2;
      const middleAngle = (angles[1] + angles[0]) / 2;
      const invertDirection = middleAngle > 0 && middleAngle < Math.PI; // On lower quadrants write text ccw
      if (invertDirection) { angles.reverse(); }
      const path = d3.path();
      path.arc(0, 0, r, angles[0], angles[1], invertDirection);   
      return path.toString();
    };

    this.mainLabels
      .selectAll('.hidden-main-label-background')
      .data(arcs)
      .join( 
        enter => enter
          .append('path')
          .attr('class', 'hidden-main-label-background')
          .attr('fill', 'none')
          .attr('id', (_, i) => `hiddenArc${i}`)
          .attr('d', function(d) {
            this._current = d;
            return middleArcLine(d);
          }),
        update => update
          .transition().duration(this.linearTransitionTime)
          .attrTween('d', function(a) {
            const i = d3.interpolate(this._current, a);
            this._current = i(0);
            return (t) => middleArcLine(i(t));
          })
      )
    
    const mainLabelThickness = this.radius * (this.mainLabelRange[1] - this.mainLabelRange[0]) * 0.6
    this.mainLabels
      .selectAll('.main-label-text')
      .data(arcs)
      .join( 
        enter => enter
          .append('text')
          .append('textPath')
            .attr('class', 'main-label-text')
            .style('text-anchor', 'middle')
            .style('alignment-baseline', 'middle')
            .style('font-weight', 800)
            .style('text-transform', 'uppercase')
            .style('font-size', mainLabelThickness)
            .style('fill', 'white')
            .attr('startOffset','50%')
            .attr('xlink:href', (_, i) => `#hiddenArc${i}` )
            .text(d => d.data.translatedName),
        update => update
          .transition().duration(this.linearTransitionTime)
          .attr('xlink:href', (_, i) => `#hiddenArc${i}` )
          .text(d => d.data.translatedName),
      )

    return arcs;
  }

  drawSubmetrics(mainSubdivisions) {
    const agreementScale = d3.scaleLinear()
      .domain([0, d3.max(
        this.data.reduce((stats, emp) => stats.concat(emp.stats), []), 
        d => Math.max(d.weightedAgreementProportion, d.oppositeCitiesAgreementProportion
      ))])
      .range([0, 1])

    let finerArcs = [];
    const arcs = mainSubdivisions.reduce( (arcs, mainSubdivision, i) => {
      const { name, color } = mainSubdivision.data;
      if(this.data.find(empowerment => empowerment.type === name)) {
        const { startAngle, endAngle } = mainSubdivision;
        const subMetrics = this.data.find(empowerment => empowerment.type === name).stats
          .map(sub => { 
            return {
            ...sub,
            summary: conceptQuestions.find(q => q.reference === sub.question.ref)[`summary${this.locale}`],
            main: name,
            mainColor: color,
            cityMetricProportion: 
              this.metric === 'average' && sub.question.type !== 'yesNo' ? Math.max(0, sub.weightedAvg - 1) / 4 : 
                (this.metric === 'average' && sub.question.type === 'yesNo' ? sub.weightedAvg :
                (this.metric === 'agreementAbsolute' ? sub.weightedAgreementProportion : agreementScale(sub.weightedAgreementProportion))),
            pastCityMetricProportion: 
              this.metric === 'average' && sub.question.type !== 'yesNo' ? Math.max(0, sub.past.weightedAvg - 1) / 4 : 
                (this.metric === 'average' && sub.question.type === 'yesNo' ? sub.past.weightedAvg :
                (this.metric === 'agreementAbsolute' ? sub.past.weightedAgreementProportion : agreementScale(sub.past.weightedAgreementProportion))),
          }})

        const segments = d3.pie()
          .startAngle(startAngle)
          .endAngle(endAngle)
          .padAngle(this.padAngle)
          .sort(null)
          .value(d => 1)(subMetrics)
          .map(d => ({
            ...d,
            innerRadius: this.radius * this.subMetricRange[0],
            outerRadius: (this.subMetricRange[0] + ((this.subMetricRange[1] - this.subMetricRange[0]) * d.data.cityMetricProportion)) * this.radius - 1,
          }))

        let finerSegments = segments;

        if (name === 'travelers') {
          finerSegments = segments.map(s => {
            return {
              ...s,
              endAngle: (this.padAngle * 0.5) + (s.startAngle + s.endAngle) / 2,
              data: {
                ...s.data,
                mainColor: "#4CAF50",
                cityMetricProportion: s.data.weightedDistribution[2] / s.data.totalWeight,
                pastCityMetricProportion: s.data.past.weightedDistribution[2] / s.data.past.totalWeight,
              }
            }
          }).concat(segments.map(s => {
            return {
              ...s,
              startAngle: ((s.startAngle + s.endAngle) / 2) - (this.padAngle * 0.5),
              data: {
                ...s.data,
                mainColor: "#f44336",
                cityMetricProportion: s.data.weightedDistribution[0] / s.data.totalWeight,
                pastCityMetricProportion: s.data.past.weightedDistribution[0] / s.data.past.totalWeight,
              }
            }
          }))
          .map(d => ({
            ...d,
            innerRadius: this.radius * this.subMetricRange[0],
            outerRadius: (this.subMetricRange[0] + ((this.subMetricRange[1] - this.subMetricRange[0]) * d.data.cityMetricProportion)) * this.radius - 1,
          }))
        }
        finerArcs = finerArcs.concat(finerSegments)
        return arcs.concat(segments);
      } else {
        return arcs;
      }
    }, [])

    this.subMetricBack
      .selectAll('.sub-metric-background')
      .data(arcs.map(a => ({ ...a, outerRadius: this.radius * this.subMetricRange[1] - 1 })))
      .join( 
        enter => enter
          .append('path')
          .attr('class', d => `sub-metric-background`)
          .attr('fill', d => '#F0F0F0')
          .style('cursor', 'pointer')
          .attr('d', function(d) {
            this._current = d;
            return d3.arc()(d);
          }),
        update => update
          .transition()
          .duration(this.linearTransitionTime)
          .attrTween('d', function(a) {
            const i = d3.interpolate(this._current, a);
            this._current = i(0);
            return (t) => d3.arc()(i(t));
          })
      )

    this.subMetric
      .selectAll('.sub-metric-value')
      .data(finerArcs)
      .join( 
        enter => enter
          .append('path')
          .attr('class', d => `sub-metric-value`)
          .attr('fill', d => d.data.mainColor)
          .style('pointer-events', 'none')
          .attr('d', function(d) {
            this._current = d;
            return d3.arc()(d);
          }),
        update => update
          .transition()
          .duration(this.linearTransitionTime)
          .attr('fill', d => d.data.mainColor)
          .attrTween('d', function(a) {
            const i = d3.interpolate(this._current, a);
            this._current = i(0);
            return (t) => d3.arc()(i(t));
          })
      )

    this.subMetric
      .selectAll('.sub-metric-value-ref')
      .data(finerArcs.filter(d => !d.data.question.noEvolution).map(a => {
        const outer = (this.subMetricRange[0] + ((this.subMetricRange[1] - this.subMetricRange[0]) * a.data.pastCityMetricProportion)) * this.radius;
        return {
          ...a,
          innerRadius: outer - 2,
          outerRadius: outer
        }
      }))
      .join( 
        enter => enter
          .append('path')
          .attr('class', 'sub-metric-value-ref')
          .attr('fill', 'grey')
          .attr('stroke-width', 0.5)
          .attr('stroke', 'white')
          .style('pointer-events', 'none')
          .style('opacity', d => d.data.pastCityMetricProportion === null ? 0 : 1)
          .attr('d', function(d) {
            this._current = d;
            return d3.arc()(d);
          }),
        update => update
          .transition()
          .duration(this.linearTransitionTime)
          .attrTween('d', function(a) {
            const i = d3.interpolate(this._current, a);
            this._current = i(0);
            return (t) => d3.arc()(i(t));
          })
          .style('opacity', d => d.data.pastCityMetricProportion === null ? 0 : 1)
      )

    const self = this;
    this.subMetric
      .selectAll('.sub-metric-label')
      .data(arcs, d => d.data.question.ref)
      .join( 
        enter => enter
          .append('text')
          .attr('class', 'sub-metric-label')
          .style('font-size', this.props.width * 0.015)
          .style('text-transform', 'uppercase')
          .style('text-anchor', 'start')
          //.style('text-anchor', d => (d.startAngle + d.endAngle) / 2 * 180 / Math.PI > 180 ? 'end' : 'start')
          .attr('fill', 'black')
          .text(d => d.data.summary ? d.data.summary.toUpperCase() : '?')
          .call(this.wrap)
          .attr('transform', function(d) {
            const halfPi = Math.PI/2;
            const angles = [d.startAngle - halfPi, d.endAngle - halfPi];
            const middleAngle = (angles[1] + angles[0]) / 2;
            const revert = middleAngle * 180 / Math.PI > 90;
            var textWidth = this.getBBox().width
            return `rotate(${(middleAngle * 180 / Math.PI) - (revert ? 180 : 0)}) translate(${revert ? -(self.radius * (self.subMetricRange[1] + 0.01)) - textWidth :  (self.radius * (self.subMetricRange[1] + 0.03)) },0)`
          }),
        update => update
          .transition()
          .duration(this.linearTransitionTime)
          .style('font-weight', d => d.data.question.ref === this.selectedQuestion ? 900 : ''),
        exit => exit.remove()
      )

    return arcs;
  }

  drawQuestionHighlight(){
    let selected = null;
    //let angle = null;
    if (this.selectedQuestion) {
      const self = this;
      this.subMetricBack
        .selectAll('.sub-metric-background')
        .each(function(d) {
          if (d.data.question.ref === self.selectedQuestion) {
            selected = {
              ...d,
              innerRadius: self.radius * self.subMetricRange[1],
              outerRadius: self.props.width * 0.6,
            };
            //angle = (d.startAngle + d.endAngle) / 2 * 180 / Math.PI;
          }
        })
    }
    /*this.questionHighlight
      .select('.arrow')
      .transition()
      .attr('transform', `rotate(${angle || 0}) translate(0,${- this.radius * this.mainLabelRange[0] * 1.17})`)
      .style('opacity', angle !== null && this.selectedQuestion !== null ? 1 : 0)*/
    
    this.questionHighlight
      .select('.background')
      .transition()
      .attr('d', d => selected ? d3.arc()(selected) : null)
      .style('opacity', selected !== null && this.selectedQuestion !== null ? 1 : 0)
  }

  drawAxis() {
    const yAxis = g => g
      .attr("text-anchor", "middle")
      .call(g => g.selectAll("g")
        .data([0, 0.25, 0.5, 0.75, 1])
        .join("g")
          .attr("fill", "none")
          .call(g => g.append("circle")
              .attr("stroke", "white")
              .attr("stroke-opacity", 1)
              .attr("stroke-dasharray", 2)
              .attr("r", d => (this.subMetricRange[0] + ((this.subMetricRange[1] - this.subMetricRange[0]) * d)) * this.radius))
          .call(g => g.append("text")
              .attr("y", d => -(this.subMetricRange[0] + ((this.subMetricRange[1] - this.subMetricRange[0]) * d)) * this.radius)
              .attr("dy", "0.35em")
              .attr("stroke", "#fff")
              .attr("stroke-width", 4)
              .attr('opacity', 0.5)
              .attr('font-size', this.props.width * 0.015)
              .text(d => `${d*100}%`)
          .clone(true)
              .attr("fill", "#000")
              .attr("stroke", "none")))
      .call(g => g.append("text")
        //.attr("y", d => -this.subMetricRange[1] * this.radius)
        .attr("dy", -0.05 * this.radius)
        .attr('class', 'yAxisLegend')
        .style('text-anchor', 'end')
        .style('opacity', 0.5)
        .attr('font-size', this.props.width * 0.015)
        .attr('transform', `translate(0,${-this.subMetricRange[1] * this.radius}) rotate(-90)`)
        .text(d => this.metric === "agreementAbsolute" ? this.intl.formatMessage({ id: "app.agreementRatio" }) : this.intl.formatMessage({ id: "app.averageScore" })))

    this.yAxis.call(yAxis);
    this.yAxis
      .attr('transform', `rotate(${-12})`)
    
    this.year.append("text")
      .attr('class', 'year2017')
    this.year.append("text")
      .attr('class', 'year2019')
  }

  drawYear() {
    const firstQuestion = this.subMetric.selectAll(".sub-metric-value").data()[this.concept === 'drivers' ? 1 : 0];
    const angle = (firstQuestion.startAngle + firstQuestion.endAngle) / 2 * 180 / Math.PI;
    const pos19 = ((this.subMetricRange[0] + ((this.subMetricRange[1] - this.subMetricRange[0]) * 0.5 * firstQuestion.data.cityMetricProportion)) * this.radius - 1)
    const pos17 = ((this.subMetricRange[0] + ((this.subMetricRange[1] - this.subMetricRange[0]) * firstQuestion.data.pastCityMetricProportion)) * this.radius - 1)
    this.year.selectAll('.year2019')
      .transition()
      .attr("y", -pos19)
      .style('text-anchor', 'middle')
      .attr('fill', 'white')
      .attr('font-size', this.props.width * 0.015)
      .attr('font-weight', 'bold')
      .text("2019")
      .attr('transform', `rotate(${angle})`)
    
    this.year.selectAll('.year2017')
      .transition()
      .attr("y", -((this.radius * 0.01) + pos17))
      .style('text-anchor', 'middle')
      .attr('fill', 'grey')
      .attr('font-size', this.props.width * 0.015)
      .attr('font-weight', 'bold')
      .text("2017")
      .attr('transform', `rotate(${angle})`)

    this.yAxis.selectAll('.yAxisLegend')
      .text(this.metric === "agreementAbsolute" ? this.intl.formatMessage({ id: "app.agreementRatio" }) : this.intl.formatMessage({ id: "app.averageScore" }))
  }
}
